(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie"] && !Shopify.designMode) return;
  try {
    
  class CookieConsent extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'seraphearls_cookie_consent';
      this.maxAgeDays = parseInt(this.dataset.expiry, 10) || 7;
      this.banner = this.querySelector('[data-cookie-banner]');
      this.settingsPanel = this.querySelector('[data-cookie-settings-panel]');
      this.acceptButtons = this.querySelectorAll('[data-cookie-accept]');
      this.settingsButton = this.querySelector('[data-cookie-settings-open]');
      this.declineButton = this.querySelector('[data-cookie-decline]');
      this.confirmButton = this.querySelector('[data-cookie-confirm]');
      this.toggleButtons = this.querySelectorAll('[data-cookie-toggle]');
      this.expandButtons = this.querySelectorAll('[data-cookie-expand]');
      this.delay = 3000;
      this.showTimer = null;
      this.scheduleShow = this.scheduleShow.bind(this);
      this.openSettings = this.openSettings.bind(this);
      this.acceptAll = this.acceptAll.bind(this);
      this.declineAll = this.declineAll.bind(this);
      this.confirmChoices = this.confirmChoices.bind(this);
      this.togglePreference = this.togglePreference.bind(this);
      this.toggleDetails = this.toggleDetails.bind(this);
    }

    connectedCallback() {
      if (this.hasValidConsent()) {
        return;
      }

      if (document.readyState === 'complete') {
        this.scheduleShow();
      } else {
        window.addEventListener('load', this.scheduleShow, { once: true });
      }

      this.settingsButton?.addEventListener('click', this.openSettings);
      this.declineButton?.addEventListener('click', this.declineAll);
      this.confirmButton?.addEventListener('click', this.confirmChoices);
      this.acceptButtons.forEach((button) => button.addEventListener('click', this.acceptAll));
      this.toggleButtons.forEach((button) => button.addEventListener('click', this.togglePreference));
      this.expandButtons.forEach((button) => button.addEventListener('click', this.toggleDetails));
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.scheduleShow);
      window.clearTimeout(this.showTimer);
      this.settingsButton?.removeEventListener('click', this.openSettings);
      this.declineButton?.removeEventListener('click', this.declineAll);
      this.confirmButton?.removeEventListener('click', this.confirmChoices);
      this.acceptButtons.forEach((button) => button.removeEventListener('click', this.acceptAll));
      this.toggleButtons.forEach((button) => button.removeEventListener('click', this.togglePreference));
      this.expandButtons.forEach((button) => button.removeEventListener('click', this.toggleDetails));
    }

    scheduleShow() {
      this.showTimer = window.setTimeout(() => {
        if (!this.hasValidConsent()) {
          this.hidden = false;
        }
      }, this.delay);
    }

    openSettings() {
      this.banner.hidden = true;
      this.settingsPanel.hidden = false;
    }

    togglePreference(event) {
      const button = event.currentTarget;
      const isPressed = button.getAttribute('aria-pressed') === 'true';

      button.setAttribute('aria-pressed', String(!isPressed));
    }

    toggleDetails(event) {
      const button = event.currentTarget;
      const item = button.closest('.cookie-consent__preference-item');
      const content = item.querySelector('.cookie-consent__preference-content');
      const icon = button.querySelector('.cookie-consent__plus');
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', String(!isExpanded));
      item.classList.toggle('is-expanded', !isExpanded);
      content.hidden = isExpanded;
      icon.textContent = isExpanded ? '+' : '−';
    }

    acceptAll() {
      this.setConsent({
        necessary: true,
        functional: true,
        targeting: true,
        performance: true,
      });
    }

    declineAll() {
      this.setConsent({
        necessary: true,
        functional: false,
        targeting: false,
        performance: false,
      });
    }

    confirmChoices() {
      const preferences = { necessary: true };

      this.toggleButtons.forEach((button) => {
        preferences[button.dataset.cookieCategory] = button.getAttribute('aria-pressed') === 'true';
      });

      this.setConsent(preferences);
    }

    setConsent(preferences) {
      const expiresAt = Date.now() + this.maxAgeDays * 24 * 60 * 60 * 1000;
      const value = JSON.stringify({ accepted: true, expiresAt, preferences });

      try {
        window.localStorage.setItem(this.storageKey, value);
      } catch (error) {
        document.cookie = `${this.storageKey}=1; max-age=${this.maxAgeDays * 24 * 60 * 60}; path=/; SameSite=Lax`;
      }

      document.cookie = `${this.storageKey}=1; max-age=${this.maxAgeDays * 24 * 60 * 60}; path=/; SameSite=Lax`;
      this.hidden = true;
    }

    hasValidConsent() {
      try {
        const rawValue = window.localStorage.getItem(this.storageKey);
        const storedValue = rawValue ? JSON.parse(rawValue) : null;

        if (storedValue?.accepted && storedValue.expiresAt > Date.now()) {
          return true;
        }

        if (storedValue) {
          window.localStorage.removeItem(this.storageKey);
        }
      } catch (error) {
        return document.cookie.includes(`${this.storageKey}=1`);
      }

      return document.cookie.includes(`${this.storageKey}=1`);
    }
  }

  if (!customElements.get('cookie-consent')) {
    customElements.define('cookie-consent', CookieConsent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-grid"] && !Shopify.designMode) return;
  try {
    
  class SPFeaturedCollectionGrid {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-sp-featured-track]');
      this.previousButton = section.querySelector('[data-sp-featured-previous]');
      this.nextButton = section.querySelector('[data-sp-featured-next]');
      this.progress = section.querySelector('[data-sp-featured-progress]');
      this.cards = Array.from(section.querySelectorAll('[data-sp-featured-card]'));

      if (!this.track || this.cards.length === 0) return;

      this.isRtl = getComputedStyle(this.track).direction === 'rtl';
      this.onScroll = this.update.bind(this);
      this.onResize = this.update.bind(this);
      this.previousButton?.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.update();
    }

    scrollByCard(direction) {
      const card = this.cards[0];
      if (!card) return;

      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const rtlMultiplier = this.isRtl ? -1 : 1;
      
      // 1. 判断是否为 PC 端（这里以屏幕宽度大于 1024px 为例，你可以根据项目设计稿调整）
      const isPc = window.innerWidth > 1024;
      
      // 2. 如果是 PC 端，倍数设为 2；否则（移动端）倍数设为 1
      const cardCountToScroll = isPc ? 2.5 : 1;

      // 3. 计算最终滚动的距离
      const distance = (card.getBoundingClientRect().width + gap) * cardCountToScroll * direction * rtlMultiplier;
      
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const rawScrollLeft = this.track.scrollLeft;
      const scrollLeft = this.isRtl ? Math.abs(rawScrollLeft) : Math.max(0, rawScrollLeft);

      if (this.previousButton) this.previousButton.disabled = scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = maxScroll <= 2 || scrollLeft >= maxScroll - 2;

      if (!this.progress) return;

      if (maxScroll <= 0) {
        this.progress.style.transform = 'translateX(0)';
        return;
      }

      const trackWidth = this.progress.parentElement.clientWidth;
      const indicatorWidth = this.progress.offsetWidth;
      const x = (trackWidth - indicatorWidth) * (scrollLeft / maxScroll);
      this.progress.style.transform = `translateX(${x}px)`;
    }
  }

  document.querySelectorAll('.sp-featured-collection-grid').forEach((section) => {
    new SPFeaturedCollectionGrid(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
